import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SchoolInfoConfig {
    success: boolean;
    data: {
        product: string;
        school: { id: number; name: string, teachingPlatforms: {
            code: string;
        }[] };
        academicyearid: any;
        boardId: any;
        installation_package: any;
    };
    isError: any;
}
const initialState: SchoolInfoConfig = {
    data: {
        product: '',
        school: { id: -1, name: '', teachingPlatforms: [], },
        academicyearid: '',
        boardId: '',
        installation_package: {}
    },
    success: false,
    isError: false,
};

const schoolInfoSlice = createSlice({
    name: 'schoolInfo',
    initialState,
    reducers: {
        setSchoolInfo: (state, action: PayloadAction<SchoolInfoConfig>) => {
            state.data = action.payload.data;
            state.success = action.payload.success;
        },
        setSchoolId: (state, action: PayloadAction<number>) => {
            state.data.school.id = action.payload;
        },
    },
});

export const { setSchoolInfo, setSchoolId } = schoolInfoSlice.actions;

export default schoolInfoSlice.reducer;
